import { useState } from 'react';
import styled, { css } from 'styled-components';
import Image from 'next/image';
import COLORS from 'styles/colors';

import BREAKPOINTS from 'styles/breakpoints';
import { H2, H6 } from 'styles/typography';

import Button from 'components/Button';
import LeaderboardPlayer from '../WhatsOn/LeaderboardPlayer';

const LeaderboardContainer = styled.div`
  background-color: ${COLORS.shootoutBlue};

  ${({ backgroundImage }) =>
    backgroundImage &&
    css`
      background: url(${backgroundImage}) repeat -100px -50px;
      background-size: 100%;

      ${BREAKPOINTS.small`
        background-size: 70%;
      `};

      ${BREAKPOINTS.xLarge`
        background-size: 45%;
      `};
    `};

  ${BREAKPOINTS.small`
    padding-top: 120px;
    padding-bottom: 120px;
  `}
`;

const SectionHeading = styled.div`
  display: flex;
  justify-content: center;
  color: ${COLORS.forest};
  background-color: ${COLORS.shootoutOffWhite};
  padding-top: 60px;

  h2 {
    padding: 0 var(--gutter-side);
    text-align: center;
  }

  ${BREAKPOINTS.small`
    padding-top: 0;
    margin-bottom: 60px;
    background-color: transparent;
  `};
`;

const Leaderboard = styled.div`
  background-color: ${COLORS.shootoutOffWhite};
  max-width: 1020px;
  margin: 0 auto;
  padding: 60px 15px;

  ${BREAKPOINTS.small`
		padding: 60px;
	`};

  ${BREAKPOINTS.medium`
		border-radius: 20px;
	`};
`;

const LeaderboardHeading = styled.div`
  justify-content: center;
  color: ${COLORS.forest};
  display: none;

  ${BREAKPOINTS.small`
    display: flex;
	`};
`;

const PlayerContainer = styled.div`
  ${BREAKPOINTS.small`
    margin-top: 50px;
  `};
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 50px;
`;

const LogosContainer = styled.div`
  display: flex;
  gap: 20px;
  display: flex;
  margin-top: 60px;
  justify-content: center;
`;

const ClaysLogo = styled.div`
  position: relative;
  width: 70px;
  height: 70px;
`;

const Border = styled.div`
  width: 1px;
  height: auto;
  background-color: ${COLORS.forest};
  opacity: 0.4;
`;

const PartnerLogo = styled.div`
  position: relative;
  width: 120px;
  height: 70px;
`;

const WhatsOnLeaderboard = ({
  sectionHeading,
  leaderboardHeading,
  leaderboardPlayers,
  buttonLabel,
  claysLogo,
  partnerLogo,
  backgroundImage,
}) => {
  const collapsedValue = 5;
  const expandedValue = leaderboardPlayers.length;

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <LeaderboardContainer backgroundImage={backgroundImage}>
      <SectionHeading>
        <H2>{sectionHeading}</H2>
      </SectionHeading>

      <Leaderboard>
        <LeaderboardHeading>
          <H6>{leaderboardHeading}</H6>
        </LeaderboardHeading>

        <PlayerContainer>
          {leaderboardPlayers
            .slice(0, isExpanded ? expandedValue : collapsedValue)
            .map((item, i) => (
              <LeaderboardPlayer key={i} {...item} />
            ))}
        </PlayerContainer>

        <ButtonContainer>
          <Button onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <>Show less</> : <>{buttonLabel}</>}
          </Button>
        </ButtonContainer>

        <LogosContainer>
          <ClaysLogo>
            <Image src={claysLogo.url} alt={claysLogo.alt} layout="fill" />
          </ClaysLogo>

          <Border />

          <PartnerLogo>
            <Image
              src={partnerLogo.url}
              alt={partnerLogo.alt}
              layout="fill"
              objectFit="contain"
            />
          </PartnerLogo>
        </LogosContainer>
      </Leaderboard>
    </LeaderboardContainer>
  );
};

export default WhatsOnLeaderboard;
